// extracted by mini-css-extract-plugin
export var active = "toggle-module--active--7c1f7";
export var bright = "toggle-module--bright--f24b6";
export var innerWrapper = "toggle-module--innerWrapper--d8a0d";
export var wrapper = "toggle-module--wrapper--39b24";